// extracted by mini-css-extract-plugin
export default {"box":"index_box_wtfHC","slider":"index_slider_6Ly13","container":"index_container_rBtaK","imgMark":"index_imgMark_ct-K3"};